export default __webpack_public_path__ + "static/media/ser1.92017c33.svg";